module.exports = __webpack_public_path__ + "img/52.d1de456e.jpg";